import { I18n } from '@calendly/i18n';
import { getTimezoneName } from '@calendly/timezone-tools';
import { TimezonePicker } from '@calendly/timezone-tools/timezone-picker';
import { BareButton } from '@calendly/ui/components/bare-button';
import { useDropdown } from '@calendly/ui/components/dropdown';
import { ArrowChevronDownMiniIcon, ArrowChevronUpMiniIcon, TimezoneIcon } from '@calendly/ui/components/icons';
import { colorTextActionContrast } from '@calendly/ui/theme';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { useSelector } from 'react-redux';
import { useViewportFit } from 'hooks/useViewportFit';
import { timeNotationSelector } from 'selectors/current_user';
const containerCss = "c1m9so9g";
const Container = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(containerCss, props.className)} />;
});
const controlCss = "c52ogz8";
const Control = forwardRef((props, ref) => <BareButton ref={ref} {...props} className={classNames(controlCss, props.className)} />);
const nameCss = "n1nwysct";
const Name = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'span';
  return <Component ref={ref} {...restProps} className={classNames(nameCss, props.className)} />;
});
const pickerPullLeftCss = "p1g68cpz";
const pickerPullTopCss = "p1bxc1s9";
const pickerShiftLeft15Css = "pjuqz6i";
const pickerShiftLeft24Css = "p1q0d5yu";
const pickerExpandLeftCss = "p9q7a15";
const pickerWithDefaultOptionCss = "p1miz6pv";
const pickerCss = "po5ltx4";
const Picker = forwardRef((props, ref) => {
  const {
    pullLeft,
    pullTop,
    shiftLeft15,
    shiftLeft24,
    expandLeft,
    withDefaultOption
  } = props;
  return <TimezonePicker ref={ref} {...props} className={classNames(pickerCss, {
    [pickerPullLeftCss]: pullLeft,
    [pickerPullTopCss]: pullTop,
    [pickerShiftLeft15Css]: shiftLeft15,
    [pickerShiftLeft24Css]: shiftLeft24,
    [pickerExpandLeftCss]: expandLeft,
    [pickerWithDefaultOptionCss]: withDefaultOption
  }, props.className)} />;
});
const SwitchingArrowIcon = ({
  isOpen
}) => isOpen ? <ArrowChevronUpMiniIcon inline color={colorTextActionContrast} /> : <ArrowChevronDownMiniIcon inline color={colorTextActionContrast} />;
export const TimezoneDropdown = ({
  label = '',
  timezone,
  onSelectTimezone,
  className,
  isManaged = false,
  noIcon = false,
  shiftLeft15 = undefined,
  shiftLeft24 = undefined,
  buttonRef = null,
  expandLeft = undefined
}) => {
  const timeNotation = useSelector(timeNotationSelector);
  const [toggleDropdown, Dropdown, isOpen] = useDropdown();
  const {
    ref,
    topConflict,
    rightConflict,
    leftConflict,
    bottomConflict
  } = useViewportFit();
  const useHostTimezoneText = I18n.t('publisher.availability.schedules.admin_controlled.use_host_timezone');
  const timezoneName = () => {
    if (timezone) return getTimezoneName(timezone);
    return isManaged ? useHostTimezoneText : label;
  };
  const defaultOptionLabel = isManaged ? {
    defaultOptionLabel: useHostTimezoneText
  } : {};
  return <Container aria-labelledby="timezone-label">
      <Control className={className} onClick={toggleDropdown} aria-label={I18n.t('publisher.event_types.one_off.creation_modal.time_step.timezone')} aria-controls="timezone-picker" role="combobox" aria-expanded={isOpen} ref={buttonRef}>
        {!noIcon && <TimezoneIcon inline />}
        <Name>{timezoneName()}</Name>
        <SwitchingArrowIcon isOpen={isOpen} />
      </Control>
      <Dropdown>
        <Picker ref={ref} pullLeft={rightConflict && !leftConflict} pullTop={bottomConflict && !topConflict} id="timezone-picker" timeNotation={timeNotation} selectedId={timezone} onChange={onSelectTimezone} shiftLeft15={shiftLeft15} shiftLeft24={shiftLeft24} expandLeft={expandLeft} withDefaultOption={isManaged} {...defaultOptionLabel} />
      </Dropdown>
    </Container>;
};

require("./timezone_dropdown.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./timezone_dropdown.js");